import React, { useState, useEffect } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import RankingMonthly from "../../asset/images/ranking-monthly.svg";
import RankingYearly from "../../asset/images/ranking-yearly.svg";
import SmallLoader from "../Common/smallLoader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
} from "../../CommonMethhods/CommonMethods";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function NewRanking(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const navigate = useNavigate();
  const [rankingInfo, setRankingInFo] = useState();
  const [loader, setLoader] = useState(true);
  const getRankingTableInfo = async () => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getInFo = await axiosInstance.post(
        props.getNewRankingInfo,
        `"${encPayload}"`,
      );
      let response = ApiResDecrypt(getInFo?.data);
      const res = response.data;
      setRankingInFo(res);
      setLoader(false);
    } catch (error) {
      // if (error.request.status == 401) {
      //   localStorage.clear("");
      //   navigate("/");
      // }

      setLoader(false);
    }
  };

  useEffect(() => {
    getRankingTableInfo();
  }, []);

  const CurrentMRank = checkEmpty(rankingInfo)
    ? "0"
    : checkEmpty(rankingInfo.currentMonthRank)
    ? "0"
    : rankingInfo.currentMonthRank;

  const LastMRank = checkEmpty(rankingInfo)
    ? "0"
    : checkEmpty(rankingInfo.lastMonthRank)
    ? "0"
    : rankingInfo.lastMonthRank;

  const LastYearRank = checkEmpty(rankingInfo)
    ? "0"
    : checkEmpty(rankingInfo.lastyearRank)
    ? "0"
    : rankingInfo.lastyearRank;

  const CurrenntYearRank = checkEmpty(rankingInfo)
    ? "0"
    : checkEmpty(rankingInfo.currentyearRank)
    ? "0"
    : rankingInfo.currentyearRank;

  const MonthRank = LastMRank - CurrentMRank;
  const YearRank = LastYearRank - CurrenntYearRank;

  return (
    <>
      <div className="card-box new-ranking">
        <div className="card-title">
          <h2>{Constants.Ranking}</h2>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 bottom-mobile-screen">
            <div className="new-ranking-box">
              <div className="box-content">
                <img src={RankingMonthly} alt="RankingMonthly" />
                <p className="new-ranking-label">{Constants.Monthly}</p>
              </div>
              <div className="box-content">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <p className="new-ranking-value">{CurrentMRank}</p>

                    <span
                      className={
                        MonthRank == 0
                          ? "icon-equals-to text-blue"
                          : MonthRank < 0
                          ? "icon-arrow-left txt-red down-arrow"
                          : "icon-arrow-left up-arrow dark-green"
                      }
                    ></span>
                  </>
                )}

                {/* <span className="icon-arrow-left up-arrow dark-green"></span> */}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 ">
            <div className="new-ranking-box">
              <div className="box-content">
                <img src={RankingYearly} alt="RankingMonthly" />
                <p className="new-ranking-label">{Constants.Yearly}</p>
              </div>
              <div className="box-content">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <p className="new-ranking-value">{CurrenntYearRank}</p>
                    <span
                      className={
                        YearRank == 0
                          ? "icon-equals-to text-blue"
                          : YearRank < 0
                          ? "icon-arrow-left txt-red down-arrow"
                          : "icon-arrow-left up-arrow dark-green"
                      }
                    ></span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewRanking;
